
const button = {
  baseStyle: {
    //transition: 'all 0.3s ease',
    //color: 'text.body',
    boxShadow: 'button',
    _disabled: {
      bgColor: 'bg.button.disabled',
      color: 'text.button.disabled',
      borderColor: 'border.button.disabled',
      opacity: 1
    },
    _hover: {
      textDecoration: 'none'
    }
  },
  variants: {
    solid: {
      bgColor: 'white',
      color: 'text.body',
      borderWidth: '1px',
      borderColor: 'border.button.outline',
      _active: {
      
      }
    },
    outline: {
      color: 'text.body',
      borderWidth: '1px',
      borderColor: 'border.button.outline',
      _active: {
      
      }
    },
    primary: {
      bgColor: 'bg.button.primary',
      color: 'white'
    },
    ghost: {
      border: 'none',
      boxShadow: 'none'
    }
  },
  sizes: {
    md: {
      h: '40px',
      borderRadius: '10px',
      fontSize: '14px',
      fontWeight: 'semibold',
      letterSpacing: '-0.6px',
      lineHeight: '20px',
      p: '10px 20px'
    },
    sm: {
      h: '36px',
      minW: '36px',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: 'medium',
      letterSpacing: '-0.084px',
      lineHeight: '20px',
      p: '8px 15px'
    }
  },
  defaultProps: {
    colorScheme: false, 
  }
}

export default button;
